import React from 'react';
import { MdClose, MdEmail, MdDomain, MdCalendarToday, MdLanguage, MdPerson, MdBusiness } from 'react-icons/md';
import './CustomerOffcanvas.css';

const ScanDetailsOffcanvas = ({ show, onHide, scanData }) => {
  if (!show || !scanData) return null;

  return (
    <div className="customer-offcanvas-backdrop" onClick={onHide}>
      <div className="customer-offcanvas" onClick={(e) => e.stopPropagation()}>
        <div className="customer-offcanvas-header">
          <div className="header-content">
            <div className="customer-avatar">
              <MdPerson size={24} />
            </div>
            <div>
              <h4 className="customer-name">
                {scanData.firstName} {scanData.lastName}
              </h4>
              <p className="customer-email">{scanData.email}</p>
            </div>
          </div>
          <button className="close-btn" onClick={onHide}>
            <MdClose size={24} />
          </button>
        </div>

        <div className="customer-offcanvas-body">
          <div className="info-section">
            <h5 className="section-title">Basic Information</h5>
            
            <div className="info-item">
              <div className="info-icon">
                <MdEmail size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Email Address</span>
                <span className="info-value">{scanData.email}</span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdLanguage size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Language</span>
                <span className="info-value">{scanData.language === 'eng' ? 'English' : 'Japanese'}</span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdCalendarToday size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Created Date</span>
                <span className="info-value">{new Date(scanData.createdAt).toLocaleDateString()}</span>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h5 className="section-title">Domains ({scanData.domains.length})</h5>
            <div className="summary-content">
              {scanData.domains.map((domain, index) => (
                <div key={index} style={{padding: '4px 8px', background: '#f8f9fa', margin: '4px', borderRadius: '4px', display: 'inline-block'}}>
                  {domain}
                </div>
              ))}
            </div>
          </div>

          <div className="status-section">
            <h5 className="section-title">Scan Results</h5>
            
            <div className="status-grid">
              <div className="status-card">
                <div className="status-icon verified">
                  <span style={{fontSize: '20px', color: '#28a745'}}>✓</span>
                </div>
                <div className="status-content">
                  <span className="status-label">Successful Scans</span>
                  <span className="status-badge verified">
                    {scanData.successfullCount || 0}
                  </span>
                </div>
              </div>

              <div className="status-card">
                <div className="status-icon report">
                  <span style={{fontSize: '20px', color: '#dc3545'}}>✗</span>
                </div>
                <div className="status-content">
                  <span className="status-label">Failed Scans</span>
                  <span className="status-badge pending">
                    {scanData.failedCount || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h5 className="section-title">Company Information</h5>
            
            <div className="info-item">
              <div className="info-icon">
                <MdBusiness size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Company Name</span>
                <span className="info-value">{scanData.oemId?.companyName || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanDetailsOffcanvas;